import { NavLink } from 'react-router-dom';
import { useUiStore } from '@/stores/uiStore';

const NAV_ITEMS = [
  { to: '/dashboard', label: 'Dashboard', icon: '⌂' },
  { to: '/torrents', label: 'Torrents', icon: '⇅' },
  { to: '/downloads', label: 'Downloads', icon: '↓' },
  { to: '/completed', label: 'Completed', icon: '✓' },
  { to: '/storage', label: 'Storage', icon: '▢' },
  { to: '/activity', label: 'Activity', icon: '≡' },
  { to: '/system-health', label: 'System Health', icon: '♥' },
  { to: '/settings', label: 'Settings', icon: '⚙' },
];

function NavList({ onNavigate }: { onNavigate?: () => void }) {
  return (
    <nav aria-label="Primary" className="flex flex-col gap-1 p-sm">
      {NAV_ITEMS.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          onClick={onNavigate}
          className={({ isActive }) =>
            [
              'flex items-center gap-3 rounded-md px-3 py-2.5 text-sm font-medium transition-colors duration-200',
              isActive
                ? 'bg-primary text-text-onPrimary'
                : 'text-text-secondary hover:bg-surface-secondary hover:text-text',
            ].join(' ')
          }
        >
          <span aria-hidden="true" className="w-5 text-center">
            {item.icon}
          </span>
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}

export function Sidebar() {
  const sidebarOpen = useUiStore((s) => s.sidebarOpen);
  const closeSidebar = useUiStore((s) => s.closeSidebar);

  return (
    <>
      {/* Desktop fixed sidebar */}
      <aside className="hidden lg:flex lg:flex-col w-60 shrink-0 border-r border-border bg-surface h-screen sticky top-0">
        <div className="px-lg py-lg">
          <p className="text-lg font-bold text-primary tracking-tight">SHIVORAA PEER</p>
          <p className="text-xs text-text-muted mt-0.5">Your P2P Download Control Center</p>
        </div>
        <NavList />
      </aside>

      {/* Mobile/tablet drawer */}
      {sidebarOpen && (
        <div className="lg:hidden fixed inset-0 z-40">
          <div
            className="absolute inset-0 bg-black/50"
            onClick={closeSidebar}
            aria-hidden="true"
          />
          <aside
            className="absolute left-0 top-0 h-full w-64 bg-surface border-r border-border shadow-lg flex flex-col"
            role="dialog"
            aria-modal="true"
            aria-label="Navigation"
          >
            <div className="px-lg py-lg flex items-center justify-between">
              <div>
                <p className="text-lg font-bold text-primary tracking-tight">SHIVORAA PEER</p>
                <p className="text-xs text-text-muted mt-0.5">P2P Control Center</p>
              </div>
              <button
                type="button"
                aria-label="Close navigation"
                onClick={closeSidebar}
                className="w-8 h-8 inline-flex items-center justify-center rounded-md text-text-secondary hover:bg-surface-secondary"
              >
                ✕
              </button>
            </div>
            <NavList onNavigate={closeSidebar} />
          </aside>
        </div>
      )}
    </>
  );
}
